export default "__VITE_ASSET__cb4cea47__"